import { render, staticRenderFns } from "./UserPermissionTable.vue?vue&type=template&id=6bf7461a"
import script from "./UserPermissionTable.vue?vue&type=script&lang=js"
export * from "./UserPermissionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports